import React, { useState, useEffect, useRef } from 'react';
import Helper from '../Helper';
import useStateRef from 'react-usestateref';
import PaymentModal from './PaymentModal';
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import OrderSummary from './OrderSummary';
import { APPLICATION_JSON, ZIP_CODE_API_KEY } from '../../middleware/types';

const CheckoutBilling = ({ containerObject, templateName, contentId, dataZone }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [showTooltip1, setShowTooltip1] = useState(false);
    const [errorMessage, setErrorMessage, setErrorMessageRef] = useStateRef();
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [userChecked, setUserChecked] = useState(false);
    const [profileDetail, setProfileDetail, profileDetailRef] = useStateRef('')
    const [billingAddress, setBillingAddress, billingAddressRef] = useStateRef('')
    const [orgBillingAddress, setOrgBillingAddress, orgBillingAddressRef] = useStateRef()
    const [iframeUrl, setIframeUrl, iframeUrlRef] = useStateRef("")
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [cardDetails, setCardDetails, cardDetailsRef] = useStateRef("");
    const [showCBbutton, setShowCBbutton, showCBbuttonRef] = useStateRef(true);
    const [myOrderBoxFix, setMyOrderBoxFix] = useState(false);
    const history = useHistory();
    const [orderSummaryDetails, setOrderSummaryDetails, orderSummaryDetailsRef] = useStateRef(false);
    const [errorCodes, setErrorCodes, errorCodesRef] = useStateRef([]);
    const [formErrorMessages, setFormErrorMessages, formErrorMessagesRef] = useStateRef([]);
    const [city, setCity, cityRef] = useStateRef('');
    const [state, setState, stateRef] = useStateRef('');
    const [zipCode, setZipCode, zipCodeRef] = useStateRef('');
    const cache = useRef({});
    const [responseCode, setResponseCode] = useState(0);
    const [disabled, setDisabled, disabledRef] = useStateRef(false);
    const [search, setSearch, searchRef] = useStateRef("");
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    const location = useLocation();
    const errorFromReview = location.state;
    const errorDivRef = useRef(null);
    const [isReadOnly, setIsReadOnly, isReadOnlyRef] = useStateRef(false);
    const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef()
    const [scroll, setScroll, scrollRef] = useStateRef("no")
    const [isIframeLoaded, setIsIframeLoaded] = useState(false);
    const iframeRef = useRef(null);
    const [iframeLoading, setIframeLoading, iframeLoadingRef] = useStateRef(false);

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    const handleMouseEnter1 = () => {
        setShowTooltip1(true);
    };
    const handleMouseLeave1 = () => {
        setShowTooltip1(false);
    };
    function handleCallBackOrderSummary() {
        getOrderSummaryDetails();
    }
    const changeOrderType = (type) => {
        if (type === 'CC') {
            handleSwitchCC()
        } else {
            handleSwitchPO();
        }
    }
    const handleSwitchCC = () => {
        document.getElementById("visibleElement").classList.remove("d-none");
        document.getElementById("visibleElement").classList.add("d-block");
        if (document.getElementById("c-international-link")) {
            document.getElementById("c-international-link").classList.remove("d-none");
            document.getElementById("c-international-link").classList.add("d-block");
        }
        document.getElementById("payment-po").classList.remove("d-block");
        document.getElementById("payment-po").classList.add("d-none");
        handleRemoveErrorMsg('po');
        populateDataLayer("creditcard")
    };

    const handleSwitchCCError = () => {
        document.getElementById("visibleElement").classList.remove("d-none");
        document.getElementById("visibleElement").classList.add("d-block");
        if (document.getElementById("c-international-link")) {
            document.getElementById("c-international-link").classList.remove("d-none");
            document.getElementById("c-international-link").classList.add("d-block");
        }
        document.getElementById("payment-po").classList.remove("d-block");
        document.getElementById("payment-po").classList.add("d-none");
        handleRemoveErrorMsg('po');

    };

    const handleSwitchPO = () => {
        document.getElementById("payment-po").classList.remove("d-none");
        document.getElementById("payment-po").classList.add("d-block");
        document.getElementById("visibleElement").classList.remove("d-block");
        document.getElementById("visibleElement").classList.add("d-none");
        handleRemoveErrorMsg('cc');
        populateDataLayer("purchaseorder")
    };

    const setMyOrderBoxFixed = () => {
        // if(window.scrollY >= 250){
        //     setMyOrderBoxFix(true)
        // }else{
        //     setMyOrderBoxFix(false)
        // }
    }

    //if the credit card authorization issue occurs, below useeffect will display the error div.

    // useEffect(() => {
    //     if (errorFromReview) {
    //         console.log('errorFromReview...', errorFromReview);
    //         if (errorFromReview.key === 'FailedCreditCardAuth:pg793500604') {
    //             console.log('errorFromReview.key...', errorFromReview.key);
    //             handleSwitchCCError();
    //             document.getElementById("pdp-promo-error").classList.remove("d-none");
    //             document.getElementById("pdp-promo-error").classList.add("d-block");
    //             document.getElementById("purchase-order-error")?.classList.remove("d-none");
    //             document.getElementById("purchase-order-error")?.classList.add("d-block");
    //             //    document.getElementById('order-error-msg').innerHTML = errorFromReview.message;
    //         } else if (errorFromReview.key === 'checkOrderLimitApprovalRequirements') {
    //             console.log('errorFromReview.key...', errorFromReview.key);
    //             //    handleSwitchPO();
    //             document.getElementById("payment-po").classList.remove("d-none");
    //             document.getElementById("payment-po").classList.add("d-block");
    //             document.getElementById("pdp-promo-error")?.classList.remove("d-none");
    //             document.getElementById("pdp-promo-error")?.classList.add("d-block");
    //             document.getElementById("purchase-order-error").classList.remove("d-none");
    //             document.getElementById("purchase-order-error").classList.add("d-block");
    //             //    document.getElementById('po-order-error-msg').innerHTML = errorFromReview.message;
    //         } else if (errorFromReview.key) {
    //             console.log('errorFromReview.key...', errorFromReview.key);
    //             document.getElementById("pdp-promo-error").classList.remove("d-none");
    //             document.getElementById("pdp-promo-error").classList.add("d-block");
    //             document.getElementById("purchase-order-error")?.classList.remove("d-none");
    //             document.getElementById("purchase-order-error")?.classList.add("d-block");
    //             // document.getElementById("pdp-promo-error").classList.remove("d-block");
    //             // document.getElementById("pdp-promo-error").classList.add("d-none");
    //         }
    //     } else {
    //         console.log('errorFromReview is empty...');
    //     }

    // }, [])


    const validateBillingAddress = (key, value) => {
        switch (key) {
            case "firstName":
                var result = Helper.isEmpty(value)
                var validation = "^[a-zA-Z][a-zA-Z-'\\.\\s]*$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("firstName_error")
                    emptyFirstName.innerHTML = "First Name is a required field.";
                    document.getElementById("billing-firstName").classList.add("form-error")
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("firstName_error").innerHTML = "First Name is not a valid format.";
                    document.getElementById("billing-firstName").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("firstName_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("billing-firstName").classList.remove("form-error")
                }
                break;
            case "lastName":
                var result = Helper.isEmpty(value)
                var validation = "^[a-zA-Z0-9][A-Za-z0-9-'\\.\\s]*$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("LastName_error")
                    emptyFirstName.innerHTML = "Last Name is a required field.";
                    document.getElementById("billing-lastName").classList.add("form-error")
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("LastName_error").innerHTML = "Last Name is not a valid format.";
                    document.getElementById("billing-lastName").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("LastName_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("billing-lastName").classList.remove("form-error")
                }
                break;
            case "address1":
                var result = Helper.isEmpty(value)
                var validation = "^[a-zA-Z0-9@ ,:;\.'_\(\)\/#\&\s\-]+$"
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyErrorMessage = document.getElementById("address1_error")
                    emptyErrorMessage.innerHTML = "Street Address is a required field.";
                    document.getElementById("billing-address1").classList.add("form-error")
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("address1_error").innerHTML = "Street Address is not a valid format.";
                    document.getElementById("billing-address1").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("address1_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("billing-address1").classList.remove("form-error")
                }
                break;

            case "postalCode":
                var result = Helper.isEmpty(value)
                var validation = "[0-9]{5}"
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("postalCode_error")
                    emptyFirstName.innerHTML = "Zip Code is a required field.";
                    document.getElementById("billing-postalCode").classList.add("form-error")
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("postalCode_error").innerHTML = "Zip Code is not a valid format.";
                    document.getElementById("billing-postalCode").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("postalCode_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("billing-postalCode").classList.remove("form-error")
                }
                break;

            case "city":
                var result = Helper.isEmpty(value)
                var validation = "^[a-zA-Z0-9][A-Za-z0-9-'\\.\\s]*$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("city_error")
                    emptyFirstName.innerHTML = "City is a required field.";
                    document.getElementById("billing-city").classList.add("form-error")
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("city_error").innerHTML = "City is not a valid format.";
                    document.getElementById("billing-city").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("city_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("billing-city").classList.remove("form-error")
                }
                break;
            case "state":
                var result = Helper.isEmpty(value);
                if (result) {
                    setHasError(true)
                    document.getElementById("state_error").innerHTML = "State is a required field."
                } else {
                    var emptyFirstName = document.getElementById("state_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("billing-state").classList.remove("form-error")
                }
                break;
            default:
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
        // clearErrorMsg();
        setHasError(false)
        document.getElementById("message-error-div").classList.remove("d-block")
        document.getElementById("message-error-div").classList.add("d-none")
        document.getElementById("billing-firstName").classList.remove("form-error")
        document.getElementById("billing-lastName").classList.remove("form-error")
        document.getElementById("billing-address1").classList.remove("form-error")
        document.getElementById("billing-postalCode").classList.remove("form-error")
        document.getElementById("billing-city").classList.remove("form-error")
        document.getElementById("billing-state").classList.remove("form-error")
        if (showCBbuttonRef.current === true) {
            var actionUrl = "apply-billing-address";
            var formData = new FormData(event.target);
            console.log('formData...', formData);
            const formValue = Object.fromEntries(formData.entries());
            console.log('formValue...', formValue);
            // Object.entries(formValue).map(([key, value], keyIndex) => {
            //     validateBillingAddress(key, value)
            // })
            if (!hasErrorRef.current) {
                setHasError(false)
                // setIsLoading(true)
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/${actionUrl}`, {
                    method: 'POST',
                    headers: new Headers({
                        "content-Type": "application/json",
                    }),
                    body: JSON.stringify(formValue)
                }).then(res => res.json())
                    .then(res => {
                        console.log("res billing", res);
                        if (res.result === "success") {
                            if (res.response.error == "true") {
                                setIsLoading(false)
                                setErrorCodes(res.response.erorrCodes);
                                setFormErrorMessages(res.response.errors);
                                document.getElementById("message-error-div").classList.remove("d-none");
                                document.getElementById("message-error-div").classList.add("d-block");
                                setShowCBbutton(true);
                                setIsReadOnly(false);
                                handleErrorMessage();
                                if (errorDivRef.current) {
                                    errorDivRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                }
                            } else {
                                setIframeUrl(res.response.iframeURL);
                                if(cardDetailsRef.current){
                                    setCardDetails("");
                                }
                                {/* commended the below line to dispay the creditCard form as listing below the address details */ }

                                // var paymentModalTriggerId = document.getElementById("triggerPayment");
                                // paymentModalTriggerId.setAttribute("data-bs-toggle", "modal")
                                // paymentModalTriggerId.setAttribute("data-bs-target", "#paymentModal");
                                // paymentModalTriggerId.click();
                                //setTimeout(handleCCButton, 8000);
                                setIframeLoading(true);
                                setShowCBbutton(false);
                                setIsReadOnly(true);
                                setShowTooltip(false);
                                setIsLoading(false)
                                var redirectPageMap = res.response ? res.response : "";
                                var redirectPage = redirectPageMap.redirectPage ? redirectPageMap.redirectPage : "";
                            }

                            // window.location.href = `${window.location.protocol}//${window.location.hostname}${redirectPage}`;
                        } else {
                            setIsLoading(false)
                            const error = res._ERROR_MESSAGE_;
                            setErrorMessage(error);
                            document.getElementById("message-error-div").classList.remove("d-none")
                            document.getElementById("message-error-div").classList.add("d-block")
                            var emptyFirstName = document.getElementById("resultExisitingError")
                            emptyFirstName.innerHTML = setErrorMessageRef.current;
                        }
                    })
            }else{
                setShowCBbutton(true);
                setIsReadOnly(false);
            }
        } else {
            var creditCardType = "";
            var creditCardNumber = "";
            var creditCardExpirationMonth = "";
            var creditCardExpirationYear = "";
            var transactionId = "";
            var referenceNumber = "";
            var firstName = "";
            var lastName = "";
            var address = "";
            var postalCode = "";
            var city = "";
            var state = "";
            var searchParam = ""
            var formData = new FormData(event.target);
            console.log("formData---->1",formData)
            if (formData) {
                creditCardType = formData.get("creditCardType")
                creditCardExpirationMonth = formData.get("creditCardExpirationMonth")
                creditCardNumber = formData.get("creditCardNumber")
                creditCardExpirationYear = formData.get("creditCardExpirationYear")
                referenceNumber = formData.get("referenceNumber")
                transactionId = formData.get("transactionId")
                firstName = formData.get("firstName")
                lastName = formData.get("lastName")
                address = formData.get("address1")
                postalCode = formData.get("postalCode")
                city = formData.get("city")
                state = formData.get("state")

            }
            const inputMap = {
                "applyPaymentGroupsSuccessURL": "/checkout/review",
                "applyPaymentGroupsErrorURL": "/checkout/billing",
                "applyPaymentGroups": "true",
                "paymentMethod": "creditCard",
                "creditCardType": creditCardType ? creditCardType : "",
                "creditCardNumber": creditCardNumber ? creditCardNumber : "",
                "creditCardExpirationMonth": creditCardExpirationMonth ? creditCardExpirationMonth : "",
                "creditCardExpirationYear": creditCardExpirationYear ? creditCardExpirationYear : "",
                "poNumber": referenceNumber ? referenceNumber : "",
                "transactionId": transactionId ? transactionId : "",
                "invoiceNumber": "",
                "firstName": firstName ? firstName : "",
                "lastName": lastName ? lastName : "",
                "address.address1": address ? address : "",
                "postalCode": postalCode ? postalCode : "",
                "city": city ? city : "",
                "state": state ? state : ""
            }
            console.log("inputMap-->",inputMap);
            if (!hasErrorRef.current && inputMap?.transactionId) {
                // setIsLoading(true)
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/b2i/purchase-order/apply`, {
                    method: 'POST',
                    headers: new Headers({
                        "content-Type": "application/json",
                    }),

                    body: JSON.stringify(inputMap)
                }).then(res => res.json())
                    .then(res => {
                        console.log("result of cc ---->",res);
                        if (res.result === "success" && JSON.parse(res.response).status == "success") {
                            setIsLoading(false)
                            document.getElementById("reference-formError").classList.remove("d-block");
                            document.getElementById("reference-formError").classList.add("d-none");
                            history.push("/checkout/review");

                        } else {
                            console.log("referenceError--->")
                            setIsLoading(false)
                            document.getElementById("reference-formError").classList.remove("d-none");
                            document.getElementById("reference-formError").classList.add("d-block");
                            document.getElementById("reference-formError").innerHTML = JSON.parse(res.response)?.errorMessage[0]?.message;
                            setShowCBbutton(true);
                            setIsReadOnly(false);
                            // const error = res._ERROR_MESSAGE_;

                        }
                    })
            }else{
                setShowCBbutton(true);
                setIsReadOnly(false);
            }

        }

    }

    useEffect(() => {
        if (loaderStatus == true) {
            console.log("log in billing page loader true");
        } else {
            console.log("log in billing page loader false");
            localStorage.removeItem('specialInstruction');
            localStorage.removeItem('additionalInstruction');
            setSearch(window.location.pathname)
            getOrderSummaryDetails();
            window.addEventListener("scroll", setMyOrderBoxFixed)
            if (errorFromReview) {
                console.log('errorFromReview...', errorFromReview);
                if (errorFromReview.key === 'FailedCreditCardAuth:pg793500604') {
                    console.log('errorFromReview.key...', errorFromReview.key);
                    handleSwitchCCError();
                    document.getElementById("pdp-promo-error").classList.remove("d-none");
                    document.getElementById("pdp-promo-error").classList.add("d-block");
                    document.getElementById("purchase-order-error")?.classList.remove("d-none");
                    document.getElementById("purchase-order-error")?.classList.add("d-block");
                    setShowCBbutton(true);
                    setIsReadOnly(false);
                    //    document.getElementById('order-error-msg').innerHTML = errorFromReview.message;
                } else if (errorFromReview.key === 'checkOrderLimitApprovalRequirements') {
                    console.log('errorFromReview.key...', errorFromReview.key);
                    //    handleSwitchPO();
                    document.getElementById("payment-po").classList.remove("d-none");
                    document.getElementById("payment-po").classList.add("d-block");
                    document.getElementById("pdp-promo-error")?.classList.remove("d-none");
                    document.getElementById("pdp-promo-error")?.classList.add("d-block");
                    document.getElementById("purchase-order-error").classList.remove("d-none");
                    document.getElementById("purchase-order-error").classList.add("d-block");
                    //    document.getElementById('po-order-error-msg').innerHTML = errorFromReview.message;
                } else if (errorFromReview.key) {
                    console.log('errorFromReview.key...', errorFromReview.key);
                    document.getElementById("pdp-promo-error").classList.remove("d-none");
                    document.getElementById("pdp-promo-error").classList.add("d-block");
                    document.getElementById("purchase-order-error")?.classList.remove("d-none");
                    document.getElementById("purchase-order-error")?.classList.add("d-block");
                    // document.getElementById("pdp-promo-error").classList.remove("d-block");
                    // document.getElementById("pdp-promo-error").classList.add("d-none");
                }
            } else {
                console.log('errorFromReview is empty...');
            }


            if (containerObject && containerObject["@type"] == "CheckoutBilling" && searchRef.current == "/checkout/billing") {
                // setIsLoading(true);
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/org-billing-address`, {
                    method: 'GET'
                }).then(res => res.json())
                    .then(res => {
                        if (res.result === "success") {
                            setIsLoading(false);

                            var response = JSON.parse(res.response);
                            setOrgBillingAddress(response.response)
                        } else {
                            setIsLoading(false);
                            const error = res._ERROR_MESSAGE_;

                        }
                    })
            }

            if (containerObject && containerObject["@type"] == "CheckoutBilling" && searchRef.current == "/checkout/billing") {
                // setIsLoading(true);
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/billing-address-details`, {
                    method: 'GET'
                }).then(res => res.json())
                    .then(res => {
                        if (res.result === "success") {
                            setIsLoading(false);
                            setBillingAddress(JSON.parse(res.response).response)

                            if (billingAddressRef?.current?.displayZipcode) {
                                setZipCode(billingAddressRef.current.displayZipcode);
                            }
                            if (billingAddressRef?.current?.displayState) {
                                setState(billingAddressRef.current.displayState);
                            }
                            if (billingAddressRef?.current?.displayCity) {
                                setCity(billingAddressRef.current.displayCity)
                            }
                            // if (billingAddressRef.current && billingAddressRef.current.displayState && document.getElementById(billingAddressRef.current.displayState !== null)) {
                            //     document.getElementById(billingAddressRef.current.displayState).setAttribute("selected", "selected")
                            // }
                            if (billingAddressRef.current && billingAddressRef.current.lastUsedPaymentType && billingAddressRef.current.lastUsedPaymentType === "invoiceRequest" && billingAddressRef.current?.isOnlineAllowed && billingAddressRef.current?.isOnlineAllowed == 'true') {
                                handleSwitchPO()
                            } else {
                                handleSwitchCC()
                            }
                            if (billingAddressRef?.current && billingAddressRef.current?.displayFirstName && billingAddressRef.current.displayLastName
                                && billingAddressRef?.current?.displayAddress1 && zipCodeRef.current && cityRef.current && stateRef.current && !errorFromReview?.key ) {
                                const billingAddressForm = document.getElementById("billing-address");
                                if (billingAddressForm) {
                                    setIsLoading(true)
                                    const billingAddressEvent = { preventDefault: () => { }, target: billingAddressForm }
                                    handleSubmit(billingAddressEvent);
                                }
                            }
                            // populateDataLayer();
                        } else {
                            setIsLoading(false);
                            const error = res._ERROR_MESSAGE_;
                        }
                    })
            }
        }
    }, [])

    

    const getOrderSummaryDetails = async () => {
        const body = {
            "isReviewPage": false,
            "isShippingPage": false,
            "requiredReprice": true
        }
        var orderSummary = await Helper.getOrderSummary(body);

        setOrderSummaryDetails(orderSummary);
    }

    //get call for organization billing address
    // useEffect(() => {
    //     if (containerObject && containerObject["@type"] == "CheckoutBilling" && searchRef.current == "/checkout/billing") {
    //         // setIsLoading(true);
    //         fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/org-billing-address`, {
    //             method: 'GET'
    //         }).then(res => res.json())
    //             .then(res => {
    //                 if (res.result === "success") {
    //                     setIsLoading(false);

    //                     var response = JSON.parse(res.response);
    //                     setOrgBillingAddress(response.response)
    //                 } else {
    //                     setIsLoading(false);
    //                     const error = res._ERROR_MESSAGE_;

    //                 }
    //             })
    //     }
    // }, [])

    useEffect(() => {
        setIsLoading(false);
        if (profileDetails && profileDetails.transient) {
            if (document.getElementById("c-international-link")) {
                document.getElementById("c-international-link").classList.remove("d-block");
                document.getElementById("c-international-link").classList.add("d-none");
            }
            document.getElementById("payment-po").classList.remove("d-block");
            document.getElementById("payment-po").classList.add("d-none");
            document.getElementById("visibleElement").classList.remove("d-none");
            document.getElementById("visibleElement").classList.add("d-block");
        }
        if (profileDetails && profileDetails.userType == '2') {
            document.getElementById("visibleElement").classList.remove("d-block");
            document.getElementById("visibleElement").classList.add("d-none");
            document.getElementById("payment-po").classList.remove("d-none");
            document.getElementById("payment-po").classList.add("d-block");
            if (document.getElementById("c-international-link")) {
                document.getElementById("c-international-link").classList.remove("d-block");
                document.getElementById("c-international-link").classList.add("d-none");
            }
        }
        if (profileDetails && profileDetails.userType != '2') {
            if (document.getElementById("c-international-link")) {
                document.getElementById("c-international-link").classList.remove("d-block");
                document.getElementById("c-international-link").classList.add("d-none");
            }
            document.getElementById("payment-po").classList.remove("d-block");
            document.getElementById("payment-po").classList.add("d-none");
        }
        setUserChecked(true)
    }, [profileDetails])

    // useEffect(() => {
    //     if (containerObject && containerObject["@type"] == "CheckoutBilling" && searchRef.current == "/checkout/billing") {
    //         // setIsLoading(true);
    //         fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/billing-address-details`, {
    //             method: 'GET'
    //         }).then(res => res.json())
    //             .then(res => {
    //                 if (res.result === "success") {
    //                     setIsLoading(false);
    //                     setBillingAddress(JSON.parse(res.response).response)

    //                     if (billingAddressRef?.current?.displayZipcode) {
    //                         setZipCode(billingAddressRef.current.displayZipcode);
    //                     }
    //                     if (billingAddressRef?.current?.displayState) {
    //                         setState(billingAddressRef.current.displayState);
    //                     }
    //                     if (billingAddressRef?.current?.displayCity) {
    //                         setCity(billingAddressRef.current.displayCity)
    //                     }
    //                     // if (billingAddressRef.current && billingAddressRef.current.displayState && document.getElementById(billingAddressRef.current.displayState !== null)) {
    //                     //     document.getElementById(billingAddressRef.current.displayState).setAttribute("selected", "selected")
    //                     // }
    //                     if (billingAddressRef.current && billingAddressRef.current.lastUsedPaymentType && billingAddressRef.current.lastUsedPaymentType === "invoiceRequest") {
    //                         handleSwitchPO()
    //                     } else {
    //                         handleSwitchCC()
    //                     }
    //                     // populateDataLayer();
    //                 } else {
    //                     setIsLoading(false);
    //                     const error = res._ERROR_MESSAGE_;
    //                 }
    //             })
    //     }
    // }, [])

    const populateDataLayer = (paymentType) => {
        window.dataLayer = window.dataLayer || []
        // window.dataLayer.push(billingAddressRef.current?.dataLayer?.dataLayerJson);
        // const eventData = {"event":"checkoutBilling", "channel":"Checkout", "paymentType":billingAddressRef.current?.lastUsedPaymentType, "pageName":"checkout_Billing Address & Payment (B2C)"}
        // window.dataLayer.push(eventData);
        //billingAddressRef.current?.billingPageDataLayerMap && window.dataLayer.push(billingAddressRef.current?.billingPageDataLayerMap);
        let billingdDatalayerMap = {
            "paymentType": paymentType,
            "pageName": billingAddressRef.current?.billingPageDataLayerMap?.page_name,
            "event": billingAddressRef.current?.billingPageDataLayerMap?.event,
            "channel": billingAddressRef.current?.billingPageDataLayerMap?.channel
        }
        console.log("billingdDatalayerMap new after payment", billingdDatalayerMap);
        window.dataLayer.push(billingdDatalayerMap)
    }

    const handleErrorMessage = () => {
        if (!errorCodesRef.current.includes('firstName')) {
            var firstNameDiv = document.getElementById("firstName_error");
            firstNameDiv.innerHTML = '';
        }
        if (!errorCodesRef.current.includes('lastName')) {
            var firstNameDiv = document.getElementById("lastName_error");
            firstNameDiv.innerHTML = '';
        }
        if (!errorCodesRef.current.includes('address1')) {
            var firstNameDiv = document.getElementById("address1_error");
            firstNameDiv.innerHTML = '';
        }
        if (!errorCodesRef.current.includes('postalCode')) {
            var firstNameDiv = document.getElementById("postalCode_error");
            firstNameDiv.innerHTML = '';
        }
        if (!errorCodesRef.current.includes('city')) {
            var firstNameDiv = document.getElementById("city_error");
            firstNameDiv.innerHTML = '';
        }
        if (!errorCodesRef.current.includes('state')) {
            var firstNameDiv = document.getElementById("state_error");
            firstNameDiv.innerHTML = '';
        }

        errorCodesRef.current.map((code, index) => {
            var errorDiv = document.getElementById(code + "_error")
            errorDiv.innerHTML = formErrorMessagesRef.current[index];

            document.getElementById("billing-".concat(code)).classList.add("form-error")
        })


    }

    const handleRemoveErrorMsg = (type) => {
        if (type === 'cc') {
            if (document.getElementById("firstName_error")) {
                document.getElementById("firstName_error").innerHTML = '';
                document.getElementById("billing-firstName")?.classList.remove("form-error");
            }
            if (document.getElementById("lastName_error")) {
                document.getElementById("lastName_error").innerHTML = '';
                document.getElementById("billing-lastName")?.classList.remove("form-error");
            }
            if (document.getElementById("address1_error")) {
                document.getElementById("address1_error").innerHTML = '';
                document.getElementById("billing-address1")?.classList.remove("form-error");
            }
            if (document.getElementById("postalCode_error")) {
                document.getElementById("postalCode_error").innerHTML = '';
                document.getElementById("billing-postalCode")?.classList.remove("form-error");
            }
            if (document.getElementById("city_error")) {
                document.getElementById("city_error").innerHTML = '';
                document.getElementById("billing-city")?.classList.remove("form-error");
            }
            if (document.getElementById("state_error")) {
                document.getElementById("state_error").innerHTML = '';
                document.getElementById("billing-state")?.classList.remove("form-error");
            }
            if (document.getElementById("message-error-div")) {
                document.getElementById("message-error-div").classList.remove("d-block");
                document.getElementById("message-error-div").classList.add("d-none");
            }
        } else {
            if (document.getElementById("shipping-formError")) {
                document.getElementById("shipping-formError").innerHTML = '';
                document.getElementById("shipping-formError").classList.remove("d-block");
                document.getElementById("shipping-formError").classList.add("d-none");
            }
        }

    }

    const handleContinueBilling = (event) => {
        event.preventDefault();
        var searchParam = document.getElementById("poNumber") && document.getElementById("poNumber").value;

        if (searchParam == null || searchParam == "") {
            setHasError(true);
            document.getElementById("shipping-formError").classList.remove("d-none");
            document.getElementById("shipping-formError").classList.add("d-block");
            document.getElementById("shipping-formError").innerHTML = "Purchase Order Number is a required field. If you would like to pay with a credit or purchasing card, please select the Switch to Credit Card Payment link."
        } else if (/[!@#$%^&*(),.?":{}|<>]/.test(searchParam) && searchParam.length > 25) {
            setHasError(true);
            document.getElementById("shipping-formError").classList.remove("d-none");
            document.getElementById("shipping-formError").classList.add("d-block");
            document.getElementById("shipping-formError").innerHTML = "Purchase order numbers cannot contain spaces or punctuation and must be 25 or fewer characters."
        } else {
            setHasError(false);
        }


        const inputMap = {
            "applyPaymentGroupsSuccessURL": "/checkout/review",
            "applyPaymentGroupsErrorURL": "/checkout/billing",
            "paymentMethod": "invoiceRequest",
            "creditCardType": "",
            "creditCardNumber": "",
            "creditCardExpirationMonth": "",
            "creditCardExpirationYear": "",
            "poNumber": searchParam ? searchParam : "",
            "transactionId": "",
            "invoiceNumber": searchParam ? searchParam : "",
            "firstName": "",
            "lastName": "",
            "address.address1": "",
            "postalCode": "",
            "city": "",
            "state": ""
        }


        if (!hasErrorRef.current && orderSummaryDetailsRef.current) {
            // setIsLoading(true)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/b2i/purchase-order/apply`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),

                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success" && JSON.parse(res.response).status == "success") {
                        setIsLoading(false)
                        document.getElementById("shipping-formError").classList.remove("d-block");
                        document.getElementById("shipping-formError").classList.add("d-none");
                        history.push("/checkout/review")

                    } else {
                        setIsLoading(false)
                        document.getElementById("shipping-formError").classList.remove("d-none");
                        document.getElementById("shipping-formError").classList.add("d-block");
                        //    const error = res._ERROR_MESSAGE_;
                        const errorMessage = JSON.parse(res.response).errorMessage;
                        errorMessage.map((error) => {
                            if (error) {
                                document.getElementById("shipping-formError").classList.remove("d-none");
                                document.getElementById("shipping-formError").classList.add("d-block");
                                document.getElementById("shipping-formError").innerHTML = error.message;
                            }
                        })

                    }
                })
        } else {
            console.log("hasErrorRef.current::::", hasErrorRef.current, "----------orderSummaryDetailsRef.current ::", orderSummaryDetailsRef.current);
        }
    }

    function closeCreditCard() {
        //document.getElementById("paymentCloseModal").click();
    }
    function handleEditCreditCard() {
        setShowCBbutton(true)
        setCardDetails()

        setTimeout(function () {
            document.getElementById("creditSubmit").click();
        }, 2000)


    }
    function handleCCButton(data) {
        if (data && data?.result && data?.result === "success") {
            var checkouterrMessage = document.getElementById("checkout-err")
            checkouterrMessage.innerHTML = "";
            document.getElementById("message-error-div").classList.remove("d-block")
            document.getElementById("message-error-div").classList.add("d-none")
            setCardDetails(data?.cardDetails)
            setShowCBbutton(false)
            closeCreditCard();
           
                const billingAddressForm = document.getElementById("billing-address");
                if (billingAddressForm && cardDetailsRef.current) {
                    const billingAddressEvent = { preventDefault: () => { }, target: billingAddressForm }
                    setIsLoading(true);
                    handleSubmit(billingAddressEvent);
                }
           
            
        } else if (data && data.result && data.result === "error") {
            var checkouterrMessage = document.getElementById("checkout-err")
            checkouterrMessage.innerHTML = data.message;
            document.getElementById("message-error-div").classList.remove("d-none")
            document.getElementById("message-error-div").classList.add("d-block")
            setShowCBbutton(true);
            setIsReadOnly(false);
            closeCreditCard()
        }

    }


    var clientKey = "js-SS6GCuyiIHK8JE7mMNcC4NSX2Te7lz69aKHOjggnVMYbcEVwARAWrkeRm0n6DbEt";

    const handleZipCodeApiResponse = (data) => {

        if (data.error_msg) {
            console.log('data.error_msg..', data.error_msg);
            console.log('data.error_code..', data.error_code);
            setResponseCode(data.error_code);
            // We are not showing any error to the user, simply letting the user to enter the data
        } else if ("city" in data) {
            setCity(data.city);
            setState(data.state);
            setResponseCode(0);
            if (stateRef.current && stateRef.current) {
                document.getElementById(stateRef.current).setAttribute("selected", "selected")
            }
            getOrderSummaryDetails();
        } else {
            console.log("data in else ", data);
        }
    }

    // get call to find out city and state
    function getCityAndStateByZipCode(event) {
        console.log('getCityAndStateByZipCode called...', event);
        event.preventDefault();
        setZipCode(event.target.value);
        setDisabled(true);
        setCity('');
        setState('');
        setTimeout(() => {

            handleBillingChange();

            if (zipCodeRef.current == '') {
                console.log('zipcode is empty, city and state cleared...');
                setCity('');
                setState('');
            }
            if (Helper.isValidZipcodeUS(zipCodeRef.current.trim())) {
                if (cache.current[zipCodeRef.current]) {
                    console.log("zip code found in cache!!!");
                    handleZipCodeApiResponse(cache.current[zipCodeRef.current]);
                    setDisabled(false);
                } else {
                    console.log("zip code not in cache, making API CALL!!!");
                    const url = `https://www.zipcodeapi.com/rest/${ZIP_CODE_API_KEY}/info.json/${zipCodeRef.current.trim()}/radians`;
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            'Accept': APPLICATION_JSON,
                        }
                    })
                        .then(response => {
                            var responseJson = response.json();
                            return responseJson;
                        })
                        .then(data => {
                            handleZipCodeApiResponse(data);
                            // Store in cache
                            cache.current[zipCodeRef.current] = data;
                            setDisabled(false);
                        })
                        .catch(err => {
                            console.log(("fetch catch block", err));
                            if (document.getElementById('zipcodeApiResponseCode')) {
                                console.log("inside if of zipcodeApiResponseCode");
                                setResponseCode(err.status);
                            }
                            setDisabled(false);
                        })
                }
            } else {
                console.log('invalid zip and cleared city and state');
                setCity('');
                setState('');
                setDisabled(false);
            }
        }, 500)
    }

    const handleBillingChange = () => {
        if (!showCBbuttonRef.current) {
            setShowCBbutton(true)
            setCardDetails()
            setIsReadOnly(false)
        }
    }
    function enableCCbutton(event){
        if(event && event.data && event.data.result){
         handleCCButton(event.data)
        }
       }
    useEffect(() => {
        window.addEventListener('message',enableCCbutton)
        setScreenWidth(screen.width);
        console.log("screen width",screen.width)
        if(screenWidthRef.current < 464){
          setScroll("yes")
        }
    }, [])

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row  `}>

            {isLoading ? <Loader /> : ''}
            {/* <PaymentModal url={iframeUrlRef.current} handleCCButton={handleCCButton} />
            <p className='m-0' id="triggerPayment"></p> */}
            <div className="c-container">
                <div className="row justify-content-center c-account-page c-school-page c-shipping-page">
                    <div className="col-12 col-md-11 my-md-5 my-2 px-0">
                        <div className="row">

                            <div className="col-12 col-md-8" id="visibleElement">
                                <div id="message-error-div" ref={errorDivRef} className="message message-red form-error-messages col-md-12 mx-auto">
                                    <p id='checkout-err' style={{ color: "black" }}></p>
                                    <div className="col-12">
                                        <div id='resultExisitingError' style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div>
                                        <div id='firstName_error' style={{ color: "black" }}></div>
                                        <div id='lastName_error' style={{ color: "black" }}></div>
                                        <div id='address1_error' style={{ color: "black" }} ></div>
                                        <div id='postalCode_error' style={{ color: "black" }}></div>
                                        <div id='city_error' style={{ color: "black" }}></div>
                                        <div id='state_error' style={{ color: "black" }}></div>
                                    </div>
                                </div>
                                <div class="alert alert-danger d-none" role="alert" id="pdp-promo-error">
                                    <p id='order-error-msg'>{errorFromReview?.message ? errorFromReview?.message : ''}<br />

                                    </p>
                                </div>
                                <div className="row">
                                    <div className="col-7 col-md-6 text-left mb-3 d-flex">
                                        <h1 className="c-account-heading">Billing Address</h1>
                                        {isReadOnlyRef.current && (
                                            <span className="c-international-link checkLink ms-2" onMouseEnter={handleMouseEnter} onClick={handleBillingChange}
                                                onMouseLeave={handleMouseLeave}
                                                style={{ position: 'relative' }}>
                                                edit
                                                {showTooltip && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '-30px',
                                                        left: '30px',
                                                        backgroundColor: '#fbf3bf',
                                                        color: '#333',
                                                        padding: '10px',
                                                        borderRadius: '3px',
                                                        zIndex: '1',
                                                        width: '200px',
                                                        height: 'auto',
                                                        fontSize: '0.75rem',
                                                        fontWeight: '400',
                                                        border: "0.063rem solid #ccc",
                                                        boxShadow: "0 0 0.625rem #ccc",
                                                        lineHeight: "1.125rem",
                                                        borderRadius: "0.313rem",
                                                        textAlign: "center"
                                                    }}>
                                                        <div style={{
                                                            position: 'absolute', right: '198px', bottom: '45px', marginLeft: '10px', width: '0', height: '0',
                                                            borderTop: '5px solid transparent', borderBottom: '5px solid transparent', borderRight: '7px solid #333',
                                                        }}></div>
                                                        Editing your billing address requires you to re-enter credit card details for security verification.
                                                    </div>
                                                )}
                                            </span>
                                        )}
                                    </div>
                                    {billingAddressRef.current && billingAddressRef.current.isOnlineAllowed && billingAddressRef.current.isOnlineAllowed == 'true' ?
                                        <div id="c-international-link" class="c-international-link col-5 col-md-6 text-end mb-3 d-none">
                                            <p id="switchToPO" class="c-international-link" style={{ cursor: 'pointer' }} onClick={handleSwitchPO} tabindex="8">
                                                <i class="bi bi-book-fill"></i>&nbsp;
                                                Switch to Purchase Order?
                                            </p>
                                        </div>
                                        : ""}
                                </div>
                                <div id="reference-formError" className="alert alert-danger form-error-messages" role="alert">
                                </div>
                                <form method="POST" name="billing-address" id="billing-address" className="c-account-page" data-hs-cf-bound="true" onSubmit={handleSubmit}>
                                    <div style={{ display: 'none' }}>

                                    </div><div style={{ display: 'none' }}>

                                    </div>
                                    <div className="row g-3 g-md-5 mb-3">
                                        <div className="col-md-6">
                                            <label htmlFor="firstName" className="form-label">First Name</label>
                                            <input maxlength="19" name="firstName" id="billing-firstName" type="text" className="form-control" defaultValue={billingAddressRef.current && billingAddressRef.current.displayFirstName} onChange={handleBillingChange} readOnly={isReadOnlyRef.current} />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="lastName" className="form-label">Last Name</label>
                                            <input maxlength="19" name="lastName" id="billing-lastName" type="text" className="form-control" defaultValue={billingAddressRef.current && billingAddressRef.current.displayLastName} onChange={handleBillingChange} readOnly={isReadOnlyRef.current} />
                                        </div>
                                    </div>


                                    <div className="row g-3 g-md-5 mb-3">
                                        <div className="col-md-12">
                                            <label htmlFor="address" className="form-label">Street Address</label>
                                            <input maxlength="40" name="address1" id="billing-address1" type="text" defaultValue={billingAddressRef.current && billingAddressRef.current.displayAddress1} className="form-control" onChange={handleBillingChange} readOnly={isReadOnlyRef.current} />
                                        </div>
                                    </div>

                                    <div className="row g-3 g-md-5 mb-3">
                                        <div className="col-md-6">
                                            <label htmlFor="zip" className="form-label">Zip</label>
                                            <input maxlength="10" name="postalCode" id="billing-postalCode" type="text" value={zipCodeRef.current && zipCodeRef.current ? zipCodeRef.current : ""} className="form-control" onChange={(e) => getCityAndStateByZipCode(e)} readOnly={isReadOnlyRef.current} />
                                            <input id="zipcodeApiResponseCode" name='zipcodeApiResponseCode' type="hidden" value={responseCode} />
                                        </div>
                                        <div className="col"></div>
                                    </div>

                                    <div className="row g-3 g-md-5 mb-4 mb-lg-0">
                                        <div className="col-12 col-md-6">
                                            <label htmlFor="city" className="form-label">City</label>
                                            <input maxlength="30" name="city" id="billing-city" type="text" value={cityRef.current ? cityRef.current : ''} onChange={(e) => { setCity(e.currentTarget.value); handleBillingChange(); }} className="form-control" readOnly={isReadOnlyRef.current} />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <label htmlFor="state" className="form-label">State</label>
                                            <select name="state" id="billing-state" className="form-select" onChange={handleBillingChange} disabled={isReadOnlyRef.current}>
                                                <option id="default-select" selected={stateRef.current === '' ? true : false}></option>
                                                <option id="AL" selected={stateRef.current === 'AL' ? true : false} value="AL">AL - Alabama</option>
                                                <option id="AK" selected={stateRef.current === 'AK' ? true : false} value="AK">AK - Alaska</option>
                                                <option id="AZ" selected={stateRef.current === 'AZ' ? true : false} value="AZ">AZ - Arizona</option>
                                                <option id="AR" selected={stateRef.current === 'AR' ? true : false} value="AR">AR - Arkansas</option>
                                                <option id="CA" selected={stateRef.current === 'CA' ? true : false} value="CA">CA - California</option>
                                                <option id="CO" selected={stateRef.current === 'CO' ? true : false} value="CO">CO - Colorado</option>
                                                <option id="CT" selected={stateRef.current === 'CT' ? true : false} value="CT">CT - Connecticut</option>
                                                <option id="DE" selected={stateRef.current === 'DE' ? true : false} value="DE">DE - Delaware</option>
                                                <option id="DC" selected={stateRef.current === 'DC' ? true : false} value="DC">DC - District of Columbia</option>
                                                <option id="FL" selected={stateRef.current === 'FL' ? true : false} value="FL">FL - Florida</option>
                                                <option id="GA" selected={stateRef.current === 'GA' ? true : false} value="GA">GA - Georgia</option>
                                                <option id="HI" selected={stateRef.current === 'HI' ? true : false} value="HI">HI - Hawaii</option>
                                                <option id="ID" selected={stateRef.current === 'ID' ? true : false} value="ID">ID - Idaho</option>
                                                <option id="IL" selected={stateRef.current === 'IL' ? true : false} value="IL">IL - Illinois</option>
                                                <option id="IN" selected={stateRef.current === 'IN' ? true : false} value="IN">IN - Indiana</option>
                                                <option id="IA" selected={stateRef.current === 'IA' ? true : false} value="IA">IA - Iowa</option>
                                                <option id="KS" selected={stateRef.current === 'KS' ? true : false} value="KS">KS - Kansas</option>
                                                <option id="KY" selected={stateRef.current === 'KY' ? true : false} value="KY">KY - Kentucky</option>
                                                <option id="LA" selected={stateRef.current === 'LA' ? true : false} value="LA">LA - Louisiana</option>
                                                <option id="ME" selected={stateRef.current === 'ME' ? true : false} value="ME">ME - Maine</option>
                                                <option id="MD" selected={stateRef.current === 'MD' ? true : false} value="MD">MD - Maryland</option>
                                                <option id="MA" selected={stateRef.current === 'MA' ? true : false} value="MA">MA - Massachusetts</option>
                                                <option id="MI" selected={stateRef.current === 'MI' ? true : false} value="MI">MI - Michigan</option>
                                                <option id="MN" selected={stateRef.current === 'MN' ? true : false} value="MN">MN - Minnesota</option>
                                                <option id="MS" selected={stateRef.current === 'MS' ? true : false} value="MS">MS - Mississippi</option>
                                                <option id="MO" selected={stateRef.current === 'MO' ? true : false} value="MO">MO - Missouri</option>
                                                <option id="MT" selected={stateRef.current === 'MT' ? true : false} value="MT">MT - Montana</option>
                                                <option id="NE" selected={stateRef.current === 'NE' ? true : false} value="NE">NE - Nebraska</option>
                                                <option id="NV" selected={stateRef.current === 'NV' ? true : false} value="NV">NV - Nevada </option>
                                                <option id="NH" selected={stateRef.current === 'NH' ? true : false} value="NH">NH - New Hampshire</option>
                                                <option id="NJ" selected={stateRef.current === 'NJ' ? true : false} value="NJ">NJ - New Jersey</option>
                                                <option id="NM" selected={stateRef.current === 'NM' ? true : false} value="NM">NM - New Mexico</option>
                                                <option id="NY" selected={stateRef.current === 'NY' ? true : false} value="NY">NY - New York</option>
                                                <option id="NC" selected={stateRef.current === 'NC' ? true : false} value="NC">NC - North Carolina</option>
                                                <option id="ND" selected={stateRef.current === 'ND' ? true : false} value="ND">ND - North Dakota</option>
                                                <option id="OH" selected={stateRef.current === 'OH' ? true : false} value="OH">OH - Ohio</option>
                                                <option id="OK" selected={stateRef.current === 'OK' ? true : false} value="OK">OK - Oklahoma</option>
                                                <option id="OR" selected={stateRef.current === 'OR' ? true : false} value="OR">OR - Oregon</option>
                                                <option id="PA" selected={stateRef.current === 'PA' ? true : false} value="PA">PA - Pennsylvania</option>
                                                <option id="RI" selected={stateRef.current === 'RI' ? true : false} value="RI">RI - Rhode Island</option>
                                                <option id="SC" selected={stateRef.current === 'SC' ? true : false} value="SC">SC - South Carolina</option>
                                                <option id="SD" selected={stateRef.current === 'SD' ? true : false} value="SD">SD - South Dakota</option>
                                                <option id="TN" selected={stateRef.current === 'TN' ? true : false} value="TN">TN - Tennessee</option>
                                                <option id="TX" selected={stateRef.current === 'TX' ? true : false} value="TX">TX - Texas</option>
                                                <option id="UT" selected={stateRef.current === 'UT' ? true : false} value="UT">UT - Utah</option>
                                                <option id="VT" selected={stateRef.current === 'VT' ? true : false} value="VT">VT - Vermont</option>
                                                <option id="VA" selected={stateRef.current === 'VA' ? true : false} value="VA">VA - Virginia</option>
                                                <option id="WA" selected={stateRef.current === 'WA' ? true : false} value="WA">WA - Washington</option>
                                                <option id="WV" selected={stateRef.current === 'WV' ? true : false} value="WV">WV - West Virginia</option>
                                                <option id="WI" selected={stateRef.current === 'WI' ? true : false} value="WI">WI - Wisconsin</option>
                                                <option id="WY" selected={stateRef.current === 'WY' ? true : false} value="WY">WY - Wyoming</option>
                                            </select>
                                        </div>
                                    </div>
                                    {showCBbuttonRef.current === true ?
                                        <div className="row g-3 g-md-5 mb-4 mt-md-3">
                                            <div className="col-md-6 d-grid">
                                                <button id="creditSubmit" type="submit" className="btn btn-primary block c-confirm-card" >Confirm & Provide Credit Card</button>
                                            </div>
                                            <div className="col-md-6 d-grid">
                                                <img src="/vaststatic/deployed-assets/CbSite/creditcards.png" alt="credit cards" />
                                            </div>
                                        </div>
                                        : <div id="editCartBlock" class="ml-5 mt-5">
                                            {cardDetailsRef.current ? <>
                                            <div hidden> 
                                                <div class="row d-none">
                                                    <div class="col-6 col-md-6 text-left mb-3">
                                                        <h1 class="c-account-heading"> Credit Card Information </h1>
                                                    </div>
                                                </div>

                                                <div class="row g-3 mb-4">
                                                    <div class="col-md-12 credit-card-details">
                                                        <input type="hidden" class="form-control" id="refPo" tabindex="8" name="creditCardType" value={cardDetailsRef.current.CCTYPE} />
                                                        <input type="hidden" class="form-control" id="refPo" tabindex="8" name="creditCardNumber" value={cardDetailsRef.current.CARDNUMBER} />
                                                        <input type="hidden" class="form-control" id="refPo" tabindex="8" name="creditCardExpirationMonth" value={cardDetailsRef.current.MONTH} />
                                                        <input type="hidden" class="form-control" id="refPo" tabindex="8" name="transactionId" value={cardDetailsRef.current.PNREF} />
                                                        <input type="hidden" class="form-control" id="refPo" tabindex="8" name="creditCardExpirationYear" value={cardDetailsRef.current.YEAR} />

                                                        <p class="c-billing-card">
                                                            Credit Card: xxxx&nbsp;&nbsp;xxxx&nbsp;&nbsp;xxxx&nbsp;&nbsp;{cardDetailsRef.current.CARDNUMBER}
                                                            &nbsp;<span class="c-international-link checkLink" tabindex="7" onClick={() => handleEditCreditCard()}>edit</span>
                                                        </p>
                                                        <p class="c-billing-card">
                                                            Exp Date: {cardDetailsRef.current.MONTH}/{cardDetailsRef.current.YEAR}
                                                            &nbsp;<span class="c-international-link checkLink" tabindex="7" onClick={() => handleEditCreditCard()}>edit</span>
                                                        </p>

                                                    </div>
                                                    <div class="col-md-6" id="billFields">
                                                        <label for="referenceNumber" class="form-label">Reference Number (optional)</label>
                                                        <div class="c-input-tooltip">
                                                            <input type="text" class="form-control" id="refPo" tabindex="8" name="referenceNumber" />
                                                            <span className="c-tooltip m" onMouseEnter={handleMouseEnter1}
                                                                onMouseLeave={handleMouseLeave1}
                                                                style={{ position: 'relative' }}>
                                                                <i className="bi bi-question-circle-fill"></i>
                                                                {showTooltip1 && (
                                                                    <div style={{
                                                                        position: 'absolute', top: '-130px', left: '-87px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                                        backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                                        letterSpacing: '0', color: '#333', borderRadius: '0.313rem', textAlign: 'left',
                                                                        fontSize: '0.75rem', fontWeight: '400'
                                                                    }}>
                                                                        <div style={{
                                                                            position: 'absolute', top: '118px', left: '54%', marginLeft: '-15px', width: '0', height: '0',
                                                                            borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '7px solid #333',
                                                                        }}></div>
                                                                        If your organization requires a reference number (which will appear on your credit card statement), you may enter it here (optional).
                                                                    </div>
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row g-3 mb-3 mt-3">
                                                    <div class="col-md-6 d-grid">
                                                        <button type="submit" id="commit1" disabled={disabledRef.current == true ? true : ""} class="btn btn-primary block" tabindex="9">
                                                            Continue
                                                        </button>
                                                    </div>

                                                </div>
                                                </div>
                                            </> : <div class="row g-3" >
                                                <div class="col-12 col-md-8 px-md-0" >
                                                    <div class="ratio ratio-4x3">
                                                    {iframeUrlRef.current ? (
  <>
    {iframeLoadingRef.current && (
      <div className="loadingAnimation d-block" id="loading-spinner">
        <span className="spinner-border" role="status" aria-hidden="true"></span>
        <span className="visually-hidden">Loading...</span>
      </div>
    )}
    <iframe
      id="paypal-frame"
      src={iframeUrlRef.current}
      name="test_iframe"
      scrolling={scrollRef.current}
      style={{ boxShadow: 'none', border: 'none' }}
      onLoad={() => setIframeLoading(false)}  // Hide loader when iframe finished loading
      onLoadStart={() => setIframeLoading(true)} // (optional) For browsers supporting it
    />
  </>
) : (
  <div className="loadingAnimation d-block" id="loading-spinner">
    <span className="spinner-border" role="status" aria-hidden="true"></span>
    <span className="visually-hidden">Loading...</span>
  </div>
)}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            }

                                        </div>}
                                </form>
                                

                            </div>
                            {/* Billing PO */}


                            <div id="payment-po" className='col-12 col-md-8 d-block' >
                                <div class="row">
                                    <div id="shipping-formError" class="alert alert-danger form-error-messages" role="alert">
                                    </div>
                                    <div class="alert alert-danger d-none" role="alert" id="purchase-order-error">
                                        <p id='po-order-error-msg'>{errorFromReview?.message ? errorFromReview?.message : ''}<br />

                                        </p>
                                    </div>
                                    <div class="col-12 col-md-12 text-left mb-3">
                                        <h1 class="c-account-heading">Your Institution's Billing Address</h1>
                                    </div>
                                </div>

                                <div class="row g-3 mb-5">
                                    <div class="col-12 col-md-12">
                                        <div id="alertPo" class="alert alert-warning alert-yellow">
                                            <div class="row align-items-start">
                                                <div class="col-md-6">
                                                    <address>
                                                        ATTN: Billing<br />
                                                        {orgBillingAddressRef.current && orgBillingAddressRef.current.orgName && orgBillingAddressRef.current.orgName.toLowerCase()}<br />
                                                        {orgBillingAddressRef.current && orgBillingAddressRef.current.address1 && orgBillingAddressRef.current.address1.toLowerCase()}<br />
                                                        {orgBillingAddressRef.current && orgBillingAddressRef.current.city && orgBillingAddressRef.current.city.toLowerCase()},
                                                        &nbsp;{orgBillingAddressRef.current && orgBillingAddressRef.current.state && orgBillingAddressRef.current.state}
                                                        &nbsp;{orgBillingAddressRef.current && orgBillingAddressRef.current.postalCode && orgBillingAddressRef.current.postalCode.toLowerCase()}
                                                    </address>
                                                </div>

                                                <div class="col-md-6 mx-auto">
                                                    <div class="text-end">
                                                        <i class="bi bi-lock-fill"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 col-md-6 text-left mb-4">

                                        <h1 class="c-account-heading">Purchase Order</h1>
                                    </div>
                                    <div class="col-6 col-md-6 text-end mb-3">
                                        <p class="c-international-link" id="switchToCC" style={{ cursor: 'pointer' }} onClick={handleSwitchCC} tabindex="1">
                                            <i class="bi bi-credit-card"></i>Switch to Credit Card Payment?
                                        </p>
                                    </div>
                                </div>
                                <form method='post' onSubmit={handleContinueBilling}>
                                    <div class="row g-3 mb-5">
                                        <div id="billFields" class="col-md-6">

                                            <label for="poNumber" class="form-label">PO Number</label>
                                            <div class="c-input-tooltip">
                                                <input type="text" class="form-control" id="poNumber" name="poNumber" tabindex="2" />
                                                {/* <span class="c-tooltip" data-bs-html="true" data-bs-toggle="tooltip">
                                                    <i class="bi bi-question-circle-fill"></i>
                                                </span> */}
                                                <span className="c-tooltip m" onMouseEnter={handleMouseEnter}
                                                    onMouseLeave={handleMouseLeave}
                                                    style={{ position: 'relative' }}>
                                                    <i className="bi bi-question-circle-fill"></i>
                                                    {showTooltip && (
                                                        <div style={{
                                                            position: 'absolute', top: '-95px', left: '-90px', zIndex: '1', width: '200px', padding: '0.875rem',
                                                            backgroundColor: '#fbf3bf', border: '0.063rem solid #ccc', boxShadow: '0 0 0.625rem #ccc', lineHeight: '1.125rem',
                                                            letterSpacing: '0', color: '#333', borderRadius: '0.313rem', textAlign: 'left',
                                                            fontSize: '0.75rem', fontWeight: '400'
                                                        }}>
                                                            <div style={{
                                                                position: 'absolute', top: '83px', left: '54%', marginLeft: '-15px', width: '0', height: '0',
                                                                borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '7px solid #333',
                                                            }}></div>
                                                            Enter a purchase order number (no spaces, punctuation, or special charecters).
                                                        </div>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-3 mb-3 mt-3">
                                        <div class="col-md-6 d-grid">
                                            <button id="commit1" type="submit" class="btn btn-primary block" tabindex="3" >
                                                Continue
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <OrderSummary orderSummaryDetails={orderSummaryDetailsRef.current} handleCallBackOrderSummary={handleCallBackOrderSummary} />
                        </div>
                        <div id="checkoutSpacer"></div>

                    </div>
                    <div className="modal fade c-modal" id="default-modal" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                            <div className="modal-content">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                </button>
                                <div className="modal-body">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckoutBilling;